import { render } from "./ProjectPageInnerNav.vue?vue&type=template&id=3788e1a4"
import script from "./ProjectPageInnerNav.vue?vue&type=script&lang=js"
export * from "./ProjectPageInnerNav.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Website/Website/front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__